(function () {
  'use strict';

  function PostalcodeRemovalCtrl (tabName, $uibModalInstance) {
    const vm = this;
    const typeStrings = {
      ADR: 'RECIPIENTS_PAGE_ADR',
      ODR: 'RECIPIENTS_PAGE_ODR'
    };

    function confirm () {
      $uibModalInstance.close(tabName);
    }

    function cancel () {
      $uibModalInstance.dismiss();
    }

    function activate () {
      // methods
      vm.confirm = confirm;
      vm.cancel = cancel;
      vm.tabName = typeStrings[tabName];
    }

    activate();
  }

  angular.module('web2print.recipients')
    .controller('PostalcodeRemovalCtrl', PostalcodeRemovalCtrl);
})();
